import { render, staticRenderFns } from "./ServiceCallSent.vue?vue&type=template&id=9fb2ddc8&"
import script from "./ServiceCallSent.vue?vue&type=script&lang=js&"
export * from "./ServiceCallSent.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCallSent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports